<template>
    <d2-container>
        <div style="padding: 20px">
            <el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" size="small" class="search-form">
                        <el-form-item label="" prop="condition">
                            <el-input v-model="searchForm.condition" :placeholder="listNewCfg.conditionLabel"></el-input>
                        </el-form-item>
                        <!--<el-form-item label="标题" prop="title">
                            <el-input v-model="searchForm.title"></el-input>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startDate">
                            <el-date-picker
                                    v-model="searchForm.startDate"
                                    type="date"
                                    value-format="yyyy-MM-dd 00:00:00"
                                    :picker-options="pickerOptions"
                                    clearable
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endDate">
                            <el-date-picker
                                    v-model="searchForm.endDate"
                                    type="date"
                                    value-format="yyyy-MM-dd 23:59:59"
                                    :picker-options="pickerOptions"
                                    clearable
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>-->
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                            <el-button type="primary" icon="el-icon-zoom-in" @click="queryDialog.dialogFormVisible=true">高级查询</el-button>
                            <!--<el-button type="primary" @click="showAddDialog('addForm')">添加</el-button>-->
                            <el-button type="primary" icon="el-icon-plus" @click="showEditDialog(false)">添加</el-button>
                            <el-button icon="el-icon-refresh" @click="resetForm('searchForm')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" >
                    <el-table
                            ref="tableData"
                            :data="tableData"
                            size="small"
                            stripe
                            border
                            v-loading="loading"
                            :height="tabelHeight"
                            style="width: 100%;">
                        <el-table-column
                                label="序号"
                                type="index"
                                show-overflow-tooltip
                                width="50">
                        </el-table-column>
                        <el-table-column v-for="(item, index) in listNewCfg.fieldInfo"
                                :prop="item.name"
                                :label="item.label"
                                :formatter="dealField"
                                show-overflow-tooltip
                                min-width="180"
                        >
                        </el-table-column>
                        <!--<el-table-column
                                prop="links"
                                label="链接"
                                show-overflow-tooltip
                                min-width="280">
                        </el-table-column>
                        <el-table-column
                                prop="isActivation"
                                label="是否激活"
                                min-width="200"
                        >
                            <template slot-scope="scope">
                                <el-tag
                                        :type="scope.row.isActivation == 1 ? 'success' : 'info'"
                                        disable-transitions>{{scope.row.isActivation == 1?'是':'否'}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="createDate"
                                label="创建日期"
                                show-overflow-tooltip
                                :formatter="formatterTimestamp"
                                min-width="200"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="createName"
                                label="创建人"
                                show-overflow-tooltip
                                min-width="200"
                        >
                        </el-table-column>-->
                        <el-table-column
                                prop="state"
                                fixed="right"
                                label="操作"
                                show-overflow-tooltip
                                min-width="110"
                        >
                            <template slot-scope="scope">
                                <el-button @click="showEditDialog(true,scope.row,'post')" type="text" size="small">编辑</el-button>
                                <el-button @click="deleteData(scope.row,'delete',true)" type="text" size="small" style="color: #fd5252;">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="pagination-footer">
                    <el-pagination v-if="device==='mobile'"
                                   background
                                   layout="prev, pager, next"
                                   :total="pagination.total"
                                   @current-change="handleCurrentChange"
                                   style="padding: 10px;"
                    >
                    </el-pagination>
                    <el-pagination v-else
                                   background
                                   @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="pagination.currentPage"
                                   :page-sizes="pageSizeList"
                                   :page-size="pagination.pageSize"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="pagination.total"
                                   style="padding: 10px;"
                    >
                    </el-pagination>
                </el-col>
            </el-row>
        </div>
        <!--高级查询弹窗-->
        <el-dialog title="高级查询" :visible.sync="queryDialog.dialogFormVisible" :width="queryDialog.width" center><!--@close="resetForm('queryForm')"-->
            <div class="queryDialogContainer" v-loading="queryDialog.loading">
                <el-form :model="queryDialog.form" @submit.native.prevent ref="queryForm">
                    <el-row>
                        <el-col v-for="(item, index) in listNewCfg.filters" :key="index" :span="12">
                            <el-form-item v-if="item.inType=='SELECT_EXT' && !!item.inExt" :label="item.label" :prop="item.name" :label-width="queryDialog.formLabelWidth">
                                <el-select v-model="queryDialog.form[item.name]" placeholder="请选择" clearable>
                                    <el-option
                                            v-for="item in dictInfo[item.inExt]"
                                            :key="item.key"
                                            :label="item.value"
                                            :value="item.key">
                                    </el-option>
                                    <!--<el-option label="分类1"  value="shanghai"></el-option>
                                    <el-option label="分类2" value="beijing"></el-option>-->
                                </el-select>
                            </el-form-item>
                            <el-form-item v-else-if="item.inType=='INPUT_DT'" :label="item.label" :prop="item.name" :label-width="queryDialog.formLabelWidth">
                                <!-- 这里的后台存放值格式为时间戳 -->
                                <el-date-picker
                                        v-model="queryDialog.form[item.name]"
                                        type="date"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :picker-options="pickerOptions"
                                        clearable
                                        placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item v-else :label="item.label" :prop="item.name" :label-width="queryDialog.formLabelWidth">
                                <el-input v-model="queryDialog.form[item.name]" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <!--<el-col :span="12">
                        <el-form-item label="分类" prop="categoryId" :label-width="addDialog.formLabelWidth">
                            <el-select v-model="queryDialog.form.categoryId" placeholder="请选择分类">
                                &lt;!&ndash;<el-option
                                        v-for="item in categoryOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>&ndash;&gt;
                                <el-option label="分类1"  value="shanghai"></el-option>
                                <el-option label="分类2" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                        <el-col :span="12">
                            <el-form-item label="链接" prop="links" :label-width="queryDialog.formLabelWidth">
                                <el-input v-model="queryDialog.form.links" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="索引" prop="indexes" :label-width="queryDialog.formLabelWidth">
                                <el-input-number v-model="queryDialog.form.indexes" :min="1" :max="99999" label="请输入索引"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="激活" prop="IsActivation" :label-width="queryDialog.formLabelWidth">
                                <el-switch v-model="queryDialog.form.isActivation" :active-value="1" :inactive-value="0"></el-switch>
                            </el-form-item>
                        </el-col>-->
                    </el-row>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <!--<el-button @click="queryDialog.dialogFormVisible = false">取 消</el-button>-->
                <el-button type="primary" @click="queryDialog.dialogFormVisible = false;onSubmit()">查 询</el-button>
                <el-button @click="resetForm('queryForm')">重 置</el-button>
            </div>
        </el-dialog>
        <!-- 新增与修改弹窗 -->
        <el-dialog :title="editDialog.title" :visible.sync="editDialog.dialogFormVisible" :width="editDialog.width" @close="resetForm('editForm')" center>
            <div class="editDialogContainer" v-loading="editDialog.loading">
                <el-form :model="editDialog.form" @submit.native.prevent :rules="formRules" ref="editForm">
                    <el-row>
                        <el-col v-for="item in listNewCfg.editInfo" :span="12">
                            <el-form-item v-if="item.inType=='SELECT_EXT' && !!item.inExt" :label="item.label" :prop="item.name" :label-width="editDialog.formLabelWidth">
                                    <template v-if="typeof(editDialog.form[item.name]) == 'string'">
                                        <el-select v-model="editDialog.form[item.name]" placeholder="请选择" clearable>
                                            <el-option
                                                    v-for="item in getDictInfo(item.name,item.inExt,item.preField,item.nextField)"
                                                    :key="item.key"
                                                    :label="item.value"
                                                    :value="item.key+''">
                                            </el-option>
                                        </el-select>
                                    </template>
                                    <template v-else>
                                        <el-select v-model="editDialog.form[item.name]" placeholder="请选择" clearable>
                                            <el-option
                                                    v-for="item in getDictInfo(item.name,item.inExt,item.preField,item.nextField)"
                                                    :key="item.key"
                                                    :label="item.value"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </template>
                                    <!--<el-option label="分类1"  value="shanghai"></el-option>
                                    <el-option label="分类2" value="beijing"></el-option>-->
                            </el-form-item>
                            <el-form-item v-else-if="item.inType=='INPUT_DT'" :label="item.label" :prop="item.name" :label-width="editDialog.formLabelWidth">
                                <!-- 这里的后台存放值格式为时间戳 -->
                                <el-date-picker
                                        v-model="editDialog.form[item.name]"
                                        type="date"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="timestamp"
                                        :picker-options="pickerOptions"
                                        clearable
                                        placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item v-else :label="item.label" :prop="item.name" :label-width="editDialog.formLabelWidth">
                                <el-input v-model="editDialog.form[item.name]" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <!--<el-col :span="12">
                            <el-form-item label="标题" prop="title" :label-width="editDialog.formLabelWidth">
                                <el-input v-model="editDialog.form.title" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="链接" prop="links" :label-width="editDialog.formLabelWidth">
                                <el-input v-model="editDialog.form.links" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="索引" prop="indexes" :label-width="editDialog.formLabelWidth">
                                <el-input-number v-model="editDialog.form.indexes" :min="1" :max="99999" label="请输入索引"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="激活" prop="IsActivation" :label-width="editDialog.formLabelWidth">
                                <el-switch v-model="editDialog.form.isActivation" :active-value="1" :inactive-value="0"></el-switch>
                            </el-form-item>
                        </el-col>-->
                    </el-row>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialog.dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateTableDataForCfgTool('editForm')">保 存</el-button>
                <!--<el-button type="primary" @click="addTableData('editForm')">保 存（test）</el-button>-->
            </div>
        </el-dialog>
    </d2-container>
</template>

<script>
  // 导入工具模板的Mixin通用组件
  import commonKitListMixin from './../../pages/mixin/mixin-kit-common-list'

  export default {
    name: "kit-common-list",
    mixins: [
      commonKitListMixin
    ],
    components: {

    },
    props:{
      // 组件列表配置
      componentListCfg: {
          type: Object
      }
    },
    data(){
      return {
          // API接口配置
          apiCfg: {

          },
          //列表相关配置文件
          listCfg: {
              /*title:"标题"
              ,url:"/basicurlevents"
              ,field_label: ["字段一","字段一","字段一","字段一","字段一","字段一","字段一","字段一","字段一","字段一",...]
              ,field:["infoType2|typeTwoUrl","fakeCategory|typeThreeUrl","fakeTarget","analysisBy|analysisBy","foundTime=dt",...]
              ,conditionLabel:"请输入通用查询条件"*/
          },
          listNewCfg: {
              /*conditionLabel:"请输入通用查询条件",
              url: '/basicurlevents',
              fieldInfo: [
                  /!*{
                      name: 'infoType2',
                      label: '信息二级分类',
                      detail: "infoType2|typeTwoUrl"
                  },
                  {
                      name: 'fakeCategory',
                      label: '信息三级分类',
                      detail: "fakeCategory||typeThreeUrl"
                  },
                  {
                      name: 'foundTime',
                      label: '发现时间',
                      detail: "foundTime=dt"
                  }*!/
              ],
              // 过滤条件（与动态配置接口基本一致）
              filters: [
                  {
                      "name":"infoType2",
                      "label":"信息二级分类",
                      "inType":"SELECT_EXT",
                      "inExt":"typeTwoUrl",
                  },
                  {
                      "name":"url",
                      "label":"URL",
                      "inType":"INPUT",
                      "inExt":""
                  },
                  {
                      "name":"foundTime",
                      "label":"发现时间",
                      "inType":"INPUT_DT",
                      "inExt":""
                  }
              ],
              editInfo: [
                  // 格式暂时同filters
              ]*/
          }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .editDialogContainer {
        .el-input,.el-select{
            width: 80%;
        }
    }
    .queryDialogContainer {
        .el-input,.el-select{
            width: 80%;
        }
    }
</style>
